import { supabase } from '../lib/supabase';

export class StorageService {
    private static BUCKET_NAME = 'product-images'; // Nombre por defecto, ajustable según configuración real

    /**
     * Sube una imagen al bucket de Supabase y retorna su URL pública.
     * @param file Archivo a subir
     * @param path Ruta opcional dentro del bucket (ej: 'products/123')
     */
    async uploadImage(file: File, folder: string = 'uploads', bucketName: string = StorageService.BUCKET_NAME): Promise<string> {
        try {
            // Generar un nombre único para evitar colisiones
            const fileExt = file.name.split('.').pop();
            const fileName = `${folder}/${Date.now()}-${Math.random().toString(36).substring(2, 15)}.${fileExt}`;

            // Subir el archivo
            const { error: uploadError } = await supabase.storage
                .from(bucketName)
                .upload(fileName, file, {
                    cacheControl: '3600',
                    upsert: false
                });

            if (uploadError) {
                console.error('Error uploading image:', uploadError);
                throw new Error(uploadError.message);
            }

            // Obtener URL pública
            const { data } = supabase.storage
                .from(bucketName)
                .getPublicUrl(fileName);

            return data.publicUrl;
        } catch (error) {
            console.error('StorageService.uploadImage failed:', error);
            throw error;
        }
    }
}

export const storageService = new StorageService();
